import { PropsWithChildren, useState } from 'react'
import { MediaContext, MediaSelector } from '../contexts/Media.context'

const MediaProvider = ({ children }: PropsWithChildren) => {
  const [mediaSelector, setMediaSelector] = useState<MediaSelector | null>(null)
  return (
    <MediaContext.Provider
      value={{
        openMediaSelector: setMediaSelector,
        closeMediaSelector: () => setMediaSelector(null),
        media: mediaSelector,
      }}
    >
      {children}
    </MediaContext.Provider>
  )
}

export default MediaProvider
